{
  "NLAMS" : [
    {
      "code" : 1,
      "name" : "Bunge Netherlands"
    },
    {
      "code" : 2,
      "name" : "HES bulk terminal Amsterdam"
    },
    {
      "code" : 3,
      "name" : "MAJA Stuwadoors"
    },
    {
      "code" : 4,
      "name" : "Other"
    }
  ],
  "NLRTM" : [
    {
      "code" : 5,
      "name" : "ALCOA Energy"
    },
    {
      "code" : 6,
      "name" : "BSR Van Uden"
    },
    {
      "code" : 7,
      "name" : "EP Stevedoring"
    },
    {
      "code" : 8,
      "name" : "HES Bulk Terminal Maasdelta"
    },
    {
      "code" : 9,
      "name" : "HES Bulk Terminal Rotterdam"
    },
    {
      "code" : 10,
      "name" : "MAJA stuwadoors"
    },
    {
      "code" : 11,
      "name" : "MARCOR stevedoring"
    },
    {
      "code" : 12,
      "name" : "Transterminal Dordrecht"
    },
    {
      "code" : 13,
      "name" : "ZHD Stevedores"
    },
    {
      "code" : 14,
      "name" : "Other"
    }
  ]
}